import { Button } from 'antd';
import { getPresentmentLogByPresentmentId } from 'api/nach';
import xlsx from 'json-as-xlsx';

interface Props {
  record: any;
}
const DownloadAuditLogs = ({ record }: Props) => {
  const handleDownload = () => {
    if (record) {
      console.log(record.presentmentId);
      getPresentmentLogByPresentmentId({ presentmentFlagId: record.presentmentId })
        .then((res) => {
          let settings = {
            fileName: record.presentmentId + ' Presentment Log', // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
            RTL: false, // Display the columns from right-to-left (the default value is false)
          };
          const content = res.data || [];
          const updatedData = content.map((item, index) => ({
            ...item,
            ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
          }));

          let data = [
            {
              sheet: 'Sheet',
              columns: [
                { label: 'ROWNUM', value: 'ROWNUM' },
                { label: 'Presentment ID', value: 'presentmentId' },
                { label: 'MerchantOrder ID', value: 'merchantOrderId' },
                { label: 'Request Json', value: 'requestData' },
                { label: 'Response Json', value: 'responseData' },
                { label: 'Remarks', value: 'remarks' },
                { label: 'Created On', value: 'createdOn' },
              ],
              content: updatedData,
            },
          ];
          xlsx(data, settings);
        })
        .finally(() => {});
    }
  };
  return (
    <Button type="primary" onClick={handleDownload}>
      Download
    </Button>
  );
};

export default DownloadAuditLogs;
